import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
const allServices = ['Оскарження незаконного рішення військкомату', 'Отримання відстрочки від призову', 'Отримання військового квитка', 'Оскарження незаконного призову до Збройних Сил', 'Підготовка документів для зарахування в запас', 'Скасування повістки до військкомату', 'Проходження медичної комісії', 'Оскарження рішення військово-лікарської комісії (ВЛК)', 'Оскарження рішень і наказів атестаційних комісій', 'Вирішення адміністративних справ призовників', 'Вступ на службу та її проходження', 'Виплати військовим', 'Дезертирство, СЗЧ', 'Призов громадян України на військову службу', 'Виклик для взяття на військовий облік військовозобов’язаних', 'Військовий облік військовозобов’язаних та громадян', "Проходження служби під час виконання обов'язку в запасі", 'Звільнення з військового обов’язку громадян України', 'Виклик для проходження медичного огляду (ВЛК)', 'Аналіз документів (військових/медичних)', 'Бронювання військовозобов’язаних', 'Мобілізація, військовий облік (відстрочення, звільнення)', 'Перетин державного кордону України у військовий час', 'Захист від незаконної мобілізації', 'Захист при незаконному врученні повістки', 'Оскарження медичних висновків ВЛК', 'Допомога при отриманні виплат при пораненні, загибелі', 'Супровід щодо переведення військовослужбовця в іншу місцевість', 'Консультації щодо звільнення з військової служби', 'Вилучення транспорту та іншого майна в умовах воєнного стану', 'Фіксація та компенсація за збитки, завдані під час війни'];
export function Services() {
  return <section id="services" className="py-24 bg-white border-t border-zinc-200" data-id="element-75">
      <div className="max-w-[1400px] mx-auto px-6" data-id="element-76">
        <div className="max-w-3xl mb-16" data-id="element-77">
          <h2 className="text-4xl md:text-5xl font-extrabold text-zinc-900 mb-6 tracking-tight" data-id="element-78">
            Детальний перелік послуг
          </h2>
          <p className="text-lg text-zinc-500 font-medium" data-id="element-79">
            Ми надаємо повний спектр юридичних послуг. Кожна справа
            розглядається індивідуально з максимальною увагою до деталей.
            Оберіть питання, яке вас цікавить.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-80">
          {allServices.map((service, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: idx % 10 * 0.05
        }} className="group relative p-6 rounded-2xl border border-zinc-200 bg-zinc-50 hover:bg-zinc-900 hover:border-zinc-900 transition-all duration-300 flex flex-col justify-between min-h-[160px]" data-id="element-81">
              <div className="flex justify-between items-start mb-4" data-id="element-82">
                <span className="text-xs font-bold text-zinc-400 group-hover:text-zinc-500 transition-colors" data-id="element-83">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <ArrowUpRight size={20} className="text-zinc-300 group-hover:text-white transition-colors" data-id="element-84" />
              </div>
              <h3 className="text-sm md:text-base font-bold text-zinc-900 group-hover:text-white transition-colors leading-snug" data-id="element-85">
                {service}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}